<template>
  <div class="card mb-3" v-show="is_allow_edit || (!is_allow_edit && data.arr_skill.length > 0)">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="font-weight-bold text-primary m-0">Skill</h6>
      <p class="m-0" v-show="is_allow_edit">silakan pilih 1 atau lebih dari 1 skill yang dimiliki</p>
    </div>
    <div class="card-body">
      <div class="mdc-chip-set mdc-chip-set--filter" id="skill_chip_set" role="grid" v-show="is_allow_edit">
        <div class="mdc-chip" role="row" v-for="(data,index) in skill_arr" :key="'skill-'+index" :class="{'mdc-chip--selected': data.selected}" @click="select_skill(index)">
          <div class="mdc-chip__ripple"></div>
          <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
              <span class="mdc-chip__text">{{ data.name }}</span>
            </span>
          </span>
        </div>
      </div>
      <ul v-show="!is_allow_edit">
        <li v-for="(skill,index) in data.arr_skill" :key="'skill-'+index">{{ skill.name }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
// import '@material/chips/dist/mdc.chips.min.css'
import {MDCChipSet} from '@material/chips'

export default {
  props: ['data','is_allow_edit','skill_arr'],
  async mounted(){
    const chipSet = new MDCChipSet(document.querySelector('#skill_chip_set'))
  },
  methods:{
    select_skill(index){
      this.$emit('on-select',index)
    }
  }
}
</script>

<style lang="scss">
@use "@material/chips/mdc-chips";
</style>
